import React, { useState, useEffect } from 'react';
import * as actionTypes from '../../../redux/actions/actionTypes';

import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import {
  Input,
  Form,
  Select,
  DatePicker,
  Button,
  Modal,
  Radio,
  Spin,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import getListaProvince from '../../../redux/actions/mock/getListaProvinceDocumentoIdentificativo';
import getListaComuni from '../../../redux/actions/mock/getListaComuniDocumentoIdentificativo';
import moment from 'moment';
import Immagine from '../../../components/Immagine/Immagine';

import Navigation from '../../Navigation/Navigation';
import salvaStep from '../../../redux/actions/mock/salvaStep';

const DocumentoIdentificativo = () => {
  const datiState = useSelector(state => state.dataReducer);
  const [form] = Form.useForm();
  const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);
  const numPratica = datiState.modello.numPratica;

  const { Option } = Select;
  let dateToday = moment().format('YYYY-MM-DD');

  const documento = useSelector(
    state => state.dataReducer.modello.datiPratica.documento
  );

  const [visible, setVisible] = useState(false);
  const [documentoRiconoscimento, setDocumentoRiconoscimento] = useState(
    documento || '01'
  );
  const [numeroDocumentoRiconoscimento, setNumeroDocumentoRiconoscimento] =
    useState(null);

  const dispatch = useDispatch();

  const apiPath = useSelector(state => state.dataReducer.dataApiPath);

  const loadingComuni = useSelector(
    state => state.dataReducer.load.loadingComuni
  );
  const loadingProvince = useSelector(
    state => state.dataReducer.load.loadingProvince
  );

  const provinceDocumento = useSelector(
    state => state.dataReducer.listaProvinceDocumento.dati
  );
  const comuniDocumento = useSelector(
    state => state.dataReducer.listaComuniDocumento.dati
  );

  const provinciaDocumento = useSelector(
    state => state.dataReducer.modello.datiPratica.provinciaEmissione
  );

  let listaProvince = provinceDocumento
    ? Object.fromEntries(
        Object.entries(provinceDocumento.province)?.map(([key, value]) => [
          value.siglaProvincia,
          value.nomeProvincia,
        ])
      )
    : null;
  let listaComuni = comuniDocumento
    ? Object.fromEntries(
        Object.entries(comuniDocumento.comuni)?.map(([key, value]) => [
          value.comune,
          value.comune,
        ])
      )
    : null;

  const errorMessageProvince = useSelector(
    state => state.dataReducer.listaProvinceDocumento.dati.errorMessage
  );
  const errorMessageComuni = useSelector(
    state => state.dataReducer.listaComuniDocumento.dati.errorMessage
  );

  const erroriSalvaStep = useSelector(
    state => state.dataReducer.salvaStep.dati
  );
  const [errorMessageDocumento, setErrorMessageDocumento] = useState(null);
  const [errorMessageControlloDocumento, setErrorMessageControlloDocumento] =
    useState(null);
  const [
    errorMessageDataEmissioneDocumento,
    setErrorMessageDataEmissioneDocumento,
  ] = useState(null);
  const [errorMessageProvinciaEmissione, setErrorMessageProvinciaEmissione] =
    useState(null);
  const [errorMessageComuneEmissione, setErrorMessageComuneEmissione] =
    useState(null);

  function showModal() {
    setVisible(!visible);
  }

  function cambioDocumento(e) {
    dispatch({ type: actionTypes.CAMBIO_DOCUMENTO, payload: e.target.value });
    setDocumentoRiconoscimento(e.target.value);
    setErrorMessageDocumento(null);
    if (e.target.value === '01' || e.target.value === '03') {
      if (
        numeroDocumentoRiconoscimento &&
        numeroDocumentoRiconoscimento.length === 9
      ) {
        setErrorMessageControlloDocumento(null);
      } else {
        setErrorMessageControlloDocumento('Inserire un massimo di 9 caratteri');
      }
    } else {
      if (
        numeroDocumentoRiconoscimento &&
        numeroDocumentoRiconoscimento.length === 10
      ) {
        setErrorMessageControlloDocumento(null);
      } else {
        setErrorMessageControlloDocumento(
          'Inserire un massimo di 10 caratteri'
        );
      }
    }
  }

  function cambioProvince(provincia) {
    dispatch({
      type: actionTypes.PROVINCIA_DOCUMENTO_IDENTIFICATIVO,
      provincia: provincia,
    });
    dispatch({ type: actionTypes.LOADING_COMUNI_TRUE });
    dispatch(getListaComuni(provincia, apiPath));
    form.setFieldsValue({
      comuneEmissione: null,
    });
  }

  useEffect(() => {
    dispatch(getListaProvince(apiPath));
  }, [apiPath]); // eslint-disable-line

  useEffect(() => {
    if (provinciaDocumento !== null) {
      dispatch({ type: actionTypes.LOADING_COMUNI_TRUE });
      dispatch(getListaComuni(provinciaDocumento, apiPath));
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    if (erroriSalvaStep) {
      erroriSalvaStep.forEach(errore => {
        switch (errore.errorCode) {
          case 'numeroDocumento':
            setErrorMessageDocumento(errore.errorMessage);
            break;
          case 'dataEmissioneDocumento':
            setErrorMessageDataEmissioneDocumento(errore.errorMessage);
            break;
          case 'documento':
            setErrorMessageDocumento(errore.errorMessage);
            break;
          case 'provinciaEmissione':
            setErrorMessageProvinciaEmissione(errore.errorMessage);
            break;
          case 'comuneEmissione':
            setErrorMessageComuneEmissione(errore.errorMessage);
            break;
          default:
            setErrorMessageDocumento(null);
            setErrorMessageDataEmissioneDocumento(null);
            setErrorMessageProvinciaEmissione(null);
            setErrorMessageComuneEmissione(null);
            break;
        }
      });
    } else {
      setErrorMessageDocumento(null);
      setErrorMessageDataEmissioneDocumento(null);
      setErrorMessageProvinciaEmissione(null);
      setErrorMessageComuneEmissione(null);
    }
  }, [erroriSalvaStep]);

  function isValidCIEFormat(numeroDoc) {
    const formatoAA99999AA = /^[A-Z]{2}\d{5}[A-Z]{2}$/; // AA99999AA
    const formato9999999AA = /^\d{7}[A-Z]{2}$/; // 9999999AA
    return formatoAA99999AA.test(numeroDoc) || formato9999999AA.test(numeroDoc);
  }

  function controlloNumeroDocumento(e) {
    const re = /^[a-zA-Z0-9' ]+$/;
    let numeroDoc = e.target.value;
    if (numeroDoc !== '' || !re.test(numeroDoc)) {
      let numeroDocSenzaCaratteriSpeciali = numeroDoc.replace(/[^\w\s]/gi, '');

      form.setFieldsValue({
        numeroDocumento: numeroDocSenzaCaratteriSpeciali,
      });

      setNumeroDocumentoRiconoscimento(numeroDocSenzaCaratteriSpeciali);
      setErrorMessageDocumento(null);

      if (documento === '01') {
        // Validazione CIE: AA99999AA oppure 9999999AA
        if (
          numeroDocSenzaCaratteriSpeciali.length === 9 &&
          isValidCIEFormat(numeroDocSenzaCaratteriSpeciali)
        ) {
          setErrorMessageControlloDocumento(null);
        } else if (numeroDocSenzaCaratteriSpeciali.length === 9) {
          setErrorMessageControlloDocumento('Formato CIE non valido.');
        } else {
          setErrorMessageControlloDocumento('Inserire esattamente 9 caratteri');
        }
      } else if (
        numeroDocSenzaCaratteriSpeciali.length === 10 &&
        documento === '02'
      ) {
        setErrorMessageControlloDocumento(null);
      } else if (
        numeroDocSenzaCaratteriSpeciali.length === 9 &&
        documento === '03'
      ) {
        setErrorMessageControlloDocumento(null);
      } else {
        if (documento === '02') {
          setErrorMessageControlloDocumento(
            'Inserire un massimo di 10 caratteri'
          );
        } else if (documento === '03') {
          setErrorMessageControlloDocumento(
            'Inserire un massimo di 9 caratteri'
          );
        } else {
          setErrorMessageControlloDocumento(
            'Inserire un massimo di 9 caratteri'
          );
        }
      }
    }
  }

  function valoriIniziali() {
    let datiRicavati = {};
    const richiesta = datiState.modello.datiPratica || {};
    let nuovaRichiesta = sostituisciDate(richiesta);
    datiRicavati = Object.assign(datiRicavati, nuovaRichiesta);
    return datiRicavati;
  }

  function sostituisciDate(obj) {
    let step = obj;
    let newStep = {};
    //console.log(`Vecchio step: `,step);
    Object.entries(step).forEach(([chiave, dato]) => {
      if (moment(dato, 'YYYY-MM-DD', true).isValid()) {
        Object.assign(newStep, { [chiave]: moment(dato, 'YYYY-MM-DD') });
      } else if (moment(dato, 'YYYY-MM', true).isValid()) {
        Object.assign(newStep, { [chiave]: moment(dato, 'YYYY-MM') });
      } else {
        Object.assign(newStep, { [chiave]: dato });
      }
    });
    //console.log(`Nuovo step: `,newStep);
    return newStep;
  }

  function sostituisciDateSalvaStep(obj) {
    let step = obj;
    let newStep = {};
    Object.entries(step).forEach(([chiave, dato]) => {
      if (moment(dato, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
        if (
          chiave === 'tempoResidenza' ||
          chiave === 'dataInizioAttivita' ||
          chiave === 'dataFineAttivita'
        ) {
          Object.assign(newStep, { [chiave]: moment(dato).format('YYYY-MM') });
        } else {
          Object.assign(newStep, {
            [chiave]: moment(dato).format('YYYY-MM-DD'),
          });
        }
      } else {
        Object.assign(newStep, { [chiave]: dato });
      }
    });
    return newStep;
  }

  function onFinish(values) {
    let valoriDaSlavare = values;
    let nuoviValori = sostituisciDateSalvaStep(valoriDaSlavare);
    dispatch({ type: actionTypes.LOADING_TRUE });
    dispatch({ type: actionTypes.SALVA_DATI, payload: nuoviValori });
    dispatch(
      salvaStep(
        datiState.modello.datiPratica,
        datiState.modello.id,
        datiState.modello.codiceBroker,
        datiState.modello.currentStep,
        apiPath,
        numPratica
      )
    );
  }

  return (
    <div className={stylesForm.Form}>
      <HeaderStep
        titolo="Documento di riconoscimento"
        sottotitolo="Scegli un documento in corso di validità"
      />

      <Form form={form} onFinish={onFinish} initialValues={valoriIniziali()}>
        <Form.Item
          name="documento"
          rules={[
            {
              required: true,
              message: 'Scegli il documento',
            },
          ]}>
          <Radio.Group onChange={cambioDocumento}>
            <Radio.Button value="01" className={stylesForm.threeRadioButton}>
              Carta d'identità
            </Radio.Button>
            <Radio.Button value="02" className={stylesForm.threeRadioButton}>
              Patente
            </Radio.Button>
            <Radio.Button value="03" className={stylesForm.threeRadioButton}>
              Passaporto Italiano
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Button
          type="info"
          className={stylesForm.ButtonInfo}
          onClick={showModal}>
          Dove trovo i dati sul mio documento?
        </Button>
        <div className={stylesForm.Clear}></div>

        <div className={stylesForm.Space}></div>

        <Form.Item
          name="numeroDocumento"
          help={
            errorMessageDocumento
              ? 'Numero documento errato'
              : errorMessageControlloDocumento
          }
          rules={[
            {
              required: true,
              message: 'Scegli il numero del documento',
            },
          ]}>
          <Input
            onChange={controlloNumeroDocumento}
            minLength={documento === '02' ? 10 : 9}
            maxLength={documento === '02' ? 10 : 9}
            placeholder="numeroDocumento"
            suffix={
              <label
                className={stylesForm.floatingLabel}
                htmlFor="numeroDocumento">
                Numero Documento*
              </label>
            }
          />
        </Form.Item>

        <label
          className={stylesForm.floatingLabel}
          htmlFor="dataEmissioneDocumento">
          Data di rilascio/Emissione*
        </label>
        <Form.Item
          name="dataEmissioneDocumento"
          help={
            errorMessageDataEmissioneDocumento
              ? errorMessageDataEmissioneDocumento
              : null
          }
          rules={[
            {
              required: true,
              message: 'Scegli la data di rilascio/emissione del documento',
            },
          ]}>
          <DatePicker
            placeholder="Seleziona data"
            format="DD/MM/YYYY"
            disabledDate={d =>
              !d || d.isSameOrBefore('1900-01-01') || d.isSameOrAfter(dateToday)
            }
          />
        </Form.Item>

        <Spin spinning={loadingProvince}>
          <label
            className={stylesForm.floatingLabel}
            htmlFor="provinciaEmissione">
            Provincia*
          </label>
          <Form.Item
            name="provinciaEmissione"
            help={
              errorMessageProvinciaEmissione || errorMessageProvince || null
            }
            rules={[
              {
                required: true,
                message: 'Inserisci la provincia di emissione',
              },
            ]}>
            <Select
              onChange={cambioProvince}
              placeholder="Provincia di Emissione*"
              showSearch
              optionFilterProp="children">
              {listaProvince &&
                Object.entries(listaProvince).map(
                  ([siglaProvincia, nomeProvincia]) => (
                    <Option key={siglaProvincia} value={siglaProvincia}>
                      {nomeProvincia}
                    </Option>
                  )
                )}
            </Select>
          </Form.Item>
        </Spin>

        <Spin spinning={loadingComuni}>
          <label className={stylesForm.floatingLabel} htmlFor="comuneEmissione">
            Comune*
          </label>
          <Form.Item
            name="comuneEmissione"
            help={errorMessageComuneEmissione || errorMessageComuni || null}
            rules={[
              {
                required: true,
                message: 'Inserisci il comune di emissione',
              },
            ]}>
            <Select showSearch placeholder="Comune di Emissione*">
              {listaComuni &&
                Object.entries(listaComuni).map(([comune, value]) => (
                  <Option key={comune} value={comune}>
                    {comune}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Spin>

        <Navigation
          loadingStep={loadingStep}
          bloccoAvanzamento={errorMessageControlloDocumento ? true : false}
        />
      </Form>

      <Modal
        onCancel={showModal}
        open={visible}
        closeIcon={<Immagine urlImage={'close-modal.svg'} name="close" />}>
        <h2>Dove trovo i dati sul mio documento?</h2>
        {documentoRiconoscimento === '01' ? (
          <>
            {/* <Immagine urlImage={'documenti-riconoscimento/carta-identita/CI-Cartacea.png'} class={stylesForm.ImageDocumentoIdentificativo}  name="Carta d'Identità Cartacea" /> */}
            <Immagine
              urlImage={
                'documenti-riconoscimento/carta-identita/CI-Elettronica.png'
              }
              class={stylesForm.ImageDocumentoIdentificativo}
              name="Carta d'Identità Elettronica"
            />
          </>
        ) : documentoRiconoscimento === '02' ? (
          <>
            <Immagine
              urlImage={'documenti-riconoscimento/patente/Patente.png'}
              class={stylesForm.ImageDocumentoIdentificativo}
              name="Patente"
            />
          </>
        ) : documentoRiconoscimento === '03' ? (
          <>
            <Immagine
              urlImage={'documenti-riconoscimento/passaporto/Passaporto.png'}
              class={stylesForm.ImageDocumentoIdentificativo}
              name="Passaporto"
            />
          </>
        ) : null}
      </Modal>
    </div>
  );
};

export default DocumentoIdentificativo;
